import React from 'react'
import Link from 'next/link'

export interface BaseLinkButtonProps {
  href: string
  onClick?: (e: React.MouseEvent) => void
  children: React.ReactNode
  disabled?: boolean
  className?: string
  dataTestId?: string
}

export default function BaseLinkButton({
  href,
  onClick,
  children,
  disabled = false,
  className,
  dataTestId,
}: BaseLinkButtonProps): React.ReactElement {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={className}
      data-testid={dataTestId}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
    >
      {children}
    </Link>
  )
}
